 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"accounts":"accounts","captcha-factories~captcha-solving~captcha-stats~dashboard~landing~register":"captcha-factories~captcha-solving~captcha-stats~dashboard~landing~register","captcha-factories~captcha-solving~dashboard~register":"captcha-factories~captcha-solving~dashboard~register","captcha-factories~captcha-solving~user":"captcha-factories~captcha-solving~user","captcha-factories":"captcha-factories","captcha-solving":"captcha-solving","dashboard~funds~stripe-redirect~user":"dashboard~funds~stripe-redirect~user","dashboard":"dashboard","captcha-stats":"captcha-stats","landing":"landing","captcha-settings":"captcha-settings","confirmation~discord-redirect~discord-redirect-login~forgot-password~login~register~reset-password~s~7416a5c2":"confirmation~discord-redirect~discord-redirect-login~forgot-password~login~register~reset-password~s~7416a5c2","forgot-password~login~register~reset-password~two-fa":"forgot-password~login~register~reset-password~two-fa","register":"register","confirmation":"confirmation","user":"user","discord-redirect":"discord-redirect","discord-redirect-login":"discord-redirect-login","forgot-password":"forgot-password","login":"login","reset-password":"reset-password","two-fa":"two-fa","settings-account":"settings-account","settings-api":"settings-api","settings-security":"settings-security","funds":"funds","stripe-redirect":"stripe-redirect","help":"help","help-api-docs":"help-api-docs","help-c":"help-c","help-others":"help-others","help-p":"help-p","help-referrals":"help-referrals","support":"support","tools":"tools","tools-bots":"tools-bots","tools-libs":"tools-libs"}[chunkId]||chunkId) + "." + {"accounts":"5038541b","captcha-factories~captcha-solving~captcha-stats~dashboard~landing~register":"93f53fdb","captcha-factories~captcha-solving~dashboard~register":"637b091b","captcha-factories~captcha-solving~user":"54f560ce","captcha-factories":"b8cc89f5","captcha-solving":"3721e12c","dashboard~funds~stripe-redirect~user":"21792ab1","dashboard":"b0bd3ace","captcha-stats":"c9b6902c","landing":"3896b5cd","captcha-settings":"411bd1a8","confirmation~discord-redirect~discord-redirect-login~forgot-password~login~register~reset-password~s~7416a5c2":"82496573","forgot-password~login~register~reset-password~two-fa":"9dc6a104","register":"8fa8df4e","confirmation":"a50b6107","user":"d29b3ba3","discord-redirect":"6fa45546","discord-redirect-login":"238af58c","forgot-password":"97ad2370","login":"bf9ce7d8","reset-password":"13dcf75b","two-fa":"55d2a9e8","settings-account":"1f033662","settings-api":"63cc6e73","settings-security":"d9aa1fd0","funds":"360e4578","stripe-redirect":"dd006c5e","help":"11d3ca0e","help-api-docs":"8064942a","help-c":"2d3941ae","help-others":"c8ef5b11","help-p":"d1c91818","help-referrals":"96e4b897","support":"760f6b32","tools":"8b7ec7d0","tools-bots":"cf4e6573","tools-libs":"54416742"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"accounts":1,"captcha-factories~captcha-solving~captcha-stats~dashboard~landing~register":1,"captcha-factories":1,"captcha-solving":1,"dashboard":1,"captcha-stats":1,"landing":1,"captcha-settings":1,"forgot-password~login~register~reset-password~two-fa":1,"register":1,"confirmation":1,"user":1,"discord-redirect":1,"discord-redirect-login":1,"forgot-password":1,"login":1,"reset-password":1,"two-fa":1,"settings-account":1,"settings-api":1,"settings-security":1,"funds":1,"stripe-redirect":1,"help":1,"help-api-docs":1,"help-c":1,"help-others":1,"help-p":1,"help-referrals":1,"support":1,"tools":1,"tools-bots":1,"tools-libs":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"accounts":"accounts","captcha-factories~captcha-solving~captcha-stats~dashboard~landing~register":"captcha-factories~captcha-solving~captcha-stats~dashboard~landing~register","captcha-factories~captcha-solving~dashboard~register":"captcha-factories~captcha-solving~dashboard~register","captcha-factories~captcha-solving~user":"captcha-factories~captcha-solving~user","captcha-factories":"captcha-factories","captcha-solving":"captcha-solving","dashboard~funds~stripe-redirect~user":"dashboard~funds~stripe-redirect~user","dashboard":"dashboard","captcha-stats":"captcha-stats","landing":"landing","captcha-settings":"captcha-settings","confirmation~discord-redirect~discord-redirect-login~forgot-password~login~register~reset-password~s~7416a5c2":"confirmation~discord-redirect~discord-redirect-login~forgot-password~login~register~reset-password~s~7416a5c2","forgot-password~login~register~reset-password~two-fa":"forgot-password~login~register~reset-password~two-fa","register":"register","confirmation":"confirmation","user":"user","discord-redirect":"discord-redirect","discord-redirect-login":"discord-redirect-login","forgot-password":"forgot-password","login":"login","reset-password":"reset-password","two-fa":"two-fa","settings-account":"settings-account","settings-api":"settings-api","settings-security":"settings-security","funds":"funds","stripe-redirect":"stripe-redirect","help":"help","help-api-docs":"help-api-docs","help-c":"help-c","help-others":"help-others","help-p":"help-p","help-referrals":"help-referrals","support":"support","tools":"tools","tools-bots":"tools-bots","tools-libs":"tools-libs"}[chunkId]||chunkId) + "." + {"accounts":"37bd47da","captcha-factories~captcha-solving~captcha-stats~dashboard~landing~register":"a0c33916","captcha-factories~captcha-solving~dashboard~register":"31d6cfe0","captcha-factories~captcha-solving~user":"31d6cfe0","captcha-factories":"ee84b25e","captcha-solving":"ac84c828","dashboard~funds~stripe-redirect~user":"31d6cfe0","dashboard":"e0282369","captcha-stats":"62a12ef8","landing":"e743c9c3","captcha-settings":"c69c5d6e","confirmation~discord-redirect~discord-redirect-login~forgot-password~login~register~reset-password~s~7416a5c2":"31d6cfe0","forgot-password~login~register~reset-password~two-fa":"3d67a30c","register":"d6cf43e4","confirmation":"baa1eeec","user":"8d31e6a6","discord-redirect":"eef0b773","discord-redirect-login":"19c8ab04","forgot-password":"283fef17","login":"02d86665","reset-password":"890425cb","two-fa":"18432ba8","settings-account":"fa6e0207","settings-api":"08217494","settings-security":"ab7cd5a0","funds":"988ca59b","stripe-redirect":"7b128517","help":"245656b5","help-api-docs":"a7db46e6","help-c":"0a4cc5cb","help-others":"ab0bc369","help-p":"7a68fed9","help-referrals":"c22bf59e","support":"228e536e","tools":"ba09f188","tools-bots":"ff8ac2db","tools-libs":"b0b9155b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
